import axiosInstance from '../../http-common';
import axiosInstanceAdmin from '../../http-common-admin';
import axiosInstanceStudet from '../../http-common-students'
import axiosInstanceProf from '../../http-common-professors'
import axiosInstanceCandidatures from '../../http-common-candidatures'




export const logouAllSystem = () => {
  // Remove the token from localStorage
  localStorage.removeItem("authToken");

  // Clear the Authorization header from the Axios instance
  delete axiosInstance.defaults.headers.common["Authorization"];
  delete axiosInstanceAdmin.defaults.headers.common["Authorization"];
  delete axiosInstanceStudet.defaults.headers.common["Authorization"];
  delete axiosInstanceProf.defaults.headers.common["Authorization"];
  delete axiosInstanceCandidatures.defaults.headers.common["Authorization"];


  console.log("User logged out. Axios instance reset.");
};